import http from '@/http'
import { parseDataParam } from '@/modules/dashboards/toolbox/parseDataParam'

export async function roomVisits (roomId, { startDate, endDate } = {}) {
  const data = await http.get(`/admin/metrics/rooms/${roomId}/visits`, {
    params: {
      created_start: parseDataParam(startDate),
      created_end: parseDataParam(endDate)
    }
  }).then(response => response.data)
  return {
    totalViews: data.pageViews ?? 0,
    totalUnique: data.uniqueViews ?? 0,
    totalPeak: data.totalPeak ?? 0
  }
}
